import {
  Activity,
  AudioLines,
  Binary,
  BrainCircuit,
  ChartColumn,
  CircleCheckBig,
  Database,
  Layers,
  List,
  MessagesSquare,
  Mic,
  Scale,
  Shapes,
  ShieldCheck,
  Smile,
  Tag,
  Timer,
  type LucideIcon,
} from "lucide-react"

import { METRICS_GROUPING_OPTION, type GroupingOption } from "../constants"

// Icons for the functional Category grouping. Keys match the category labels in
// CATEGORY_DESCRIPTIONS; unknown categories fall back to the generic Layers icon.
const CATEGORY_ICONS: Record<string, LucideIcon> = {
  "Audio Fidelity": AudioLines,
  "Compliance & Scripting": ShieldCheck,
  "Conversation Quality": MessagesSquare,
  "LLM Judge": Scale,
  "Responsiveness & Timing": Timer,
  Sentiment: Smile,
  "Speech Naturalness": Mic,
  "Task Resolution": CircleCheckBig,
  "Trace & Performance": Activity,
  Other: Shapes,
}

// Icons for the methodology Type grouping. Keys match the type labels from the
// metric catalog; unknown types fall back to the generic Shapes icon.
const TYPE_ICONS: Record<string, LucideIcon> = {
  Deterministic: Binary,
  Statistical: ChartColumn,
  "ML Model": BrainCircuit,
  "LLM Judge": Scale,
  Trace: Activity,
  "Custom SQL": Database,
  Other: Shapes,
}

// Resolve the lucide icon shown beside a metric group's section title.
export function getMetricGroupIcon(
  group: { label: string },
  grouping: GroupingOption,
): LucideIcon {
  switch (grouping) {
    case METRICS_GROUPING_OPTION.TAG:
      return Tag
    case METRICS_GROUPING_OPTION.CATEGORY:
      return CATEGORY_ICONS[group.label] ?? Layers
    case METRICS_GROUPING_OPTION.TYPE:
      return TYPE_ICONS[group.label] ?? Shapes
    case METRICS_GROUPING_OPTION.NONE:
      return List
  }
}
